module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"No URL provided":"Keine URL angegeben"}}')
  delete Component.options._Ctor
}
